import React from 'react';
import { visit } from '@hotwired/turbo';
import ksFetch from '@shared/ksFetch';

const StreamerLibraryActions = ({ streamerKlip, setStreamerKlip }) => {
    const updateAndSaveStreamerKlip = async (_streamerKlip) => {
        const [data] = await ksFetch(`/streamer_klips/${_streamerKlip.id}`, {
            method: 'PUT',
            body: JSON.stringify({
                streamer_klip: {
                    enabled: _streamerKlip.enabled,
                    status: _streamerKlip.status
                }
            })
        })

        setStreamerKlip(data.streamer_klip)
    }
    return (
        <form data-turbo="false">
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center gap-2">
                    {(streamerKlip.status === "pending" || streamerKlip.status === "rejected") &&
                        <button
                            id="approve-streamer-klip"
                            type="button"
                            className="bg-[#9146ff] hover:bg-[#7c3aed] text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                            onClick={() => updateAndSaveStreamerKlip({ ...streamerKlip, status: "approved" })}
                        >
                            Approve
                        </button>
                    }
                    {streamerKlip.status === "pending" &&
                        <button
                            id="reject-streamer-klip"
                            type="button"
                            className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                            onClick={() => updateAndSaveStreamerKlip({ ...streamerKlip, status: "rejected" })}
                        >
                            Reject
                        </button>
                    }
                    {streamerKlip.status === "approved" && (
                        <div className="flex items-center gap-2">
                            <span className="text-sm text-white">Enabled:</span>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={streamerKlip.enabled}
                                    onChange={() => updateAndSaveStreamerKlip({ ...streamerKlip, enabled: !streamerKlip.enabled })}
                                />
                                <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#9146ff]/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#9146ff]"></div>
                            </label>
                        </div>
                    )}
                </div>
                <div className="flex gap-2">
                    <a
                        className="edit-streamer-klip bg-gray-600 hover:bg-gray-700 text-white p-3 rounded-md text-sm font-medium transition-all duration-200 flex items-center justify-center cursor-pointer"
                        onClick={(e) => { e.preventDefault(); visit(`/streamer_klips/${streamerKlip.id}/edit`) }}
                    >
                        <i data-feather="settings" className="w-4 h-4"></i>
                    </a>
                </div>
            </div>
        </form>
    )
}

export default StreamerLibraryActions;